import { theme } from 'antd';
import { Icons } from 'zf-web-components/icons';
import { t } from '../../i18n';
import { useHeight } from '../../../hooks';
import styles from './style.module.less';
import type { ReactElement } from 'react';

export function Empty(): ReactElement {
  const height = useHeight('.ant-table-body');
  const { token } = theme.useToken();

  return (
    <div className={styles.emptyBox} style={{ height: height - 14, minHeight: 100 }}>
      <Icons name='EmptyIcon' style={{ color: token.colorPrimary }} />
      <span className={styles.emptyText}>
        {t('暂无数据')}
      </span>
    </div>
  );
}
